import ItemContent, { ItemContentProps } from './ItemContent';
import StepperCircle, { StepperCircleProps } from './StepperCircle';
import StepperCircleSpinner, { StepperCircleSpinnerProps } from './StepperCircleSpinner';
import StepperIndicator, { StepperIndicatorProps } from './StepperIndicator';
import StepperItem, { StepperItemProps } from './StepperItem';
import StepperProgress, { StepperProgressProps } from './StepperProgress';
import StepperRoot, { StepperRootProps } from './StepperRoot';

const components = {
  render: StepperRoot,
  Item: StepperItem,
  ItemContent,
  Indicator: StepperIndicator,
  Circle: StepperCircle,
  Progress: StepperProgress,
  CircleSpinner: StepperCircleSpinner,
};

export interface StepperGeneralProps
  extends StepperCircleProps,
    StepperItemProps,
    StepperIndicatorProps,
    ItemContentProps,
    StepperCircleSpinnerProps,
    StepperProgressProps,
    StepperRootProps {}

const Stepper = components;

export default Stepper;
